import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-system_arrow",
  "use": "icon-system_arrow-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-system_arrow\"><polygon points=\"160,115.4 180.7,96 352,256 180.7,416 160,396.7 310.5,256 \" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol